import { createRoutine } from 'redux-saga-routines';

import * as types from 'types/permissions';

/**
 * @type {ReduxActionCreator}
 */
export const fetchPermissionsRoutine = createRoutine(types.FETCH_PERMISSIONS);
